import { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { LoadingOutlined } from '@ant-design/icons';
import { baseURL } from '../../utils/axios';
import { notification } from 'antd';
import { useNavigate } from 'react-router';
import Spinner from '../Spinner/Spinner';
import Place from '../../assets/icons/Place';

const MobilesearchResult = () => {
  const [searchText, setSearchText] = useState('');
  const [debouncedText, setDebouncedText] = useDebounce(searchText, 1000);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);

  const navigate = useNavigate();

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  //handle search
  const onFilterChange = (e) => {
    setSearchText(e.target.value);

    if (e.target.value === '') {
      setSearchResult(null);
    }
  };

  const searchApp = async () => {
    let token = localStorage.getItem('token');

    try {
      setLoading(true);
      const res = await fetch(`${baseURL}/search/${debouncedText}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSearchResult(data.data);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: 'Unable to get any result, please try again',
      });
      console.log(error);
    }
  };

  useEffect(() => {
    searchApp();
  }, [debouncedText]);

  return (
    <div className='mobile-search'>
      <input
        type={'search'}
        placeholder='Search for school'
        onChange={(e) => onFilterChange(e)}
      />

      <div className='mobile-search__results'>
        {loading && <Spinner />}
        {searchResult && (
          <>
            {searchResult?.schools !== 'No data found' ? (
              searchResult?.schools?.map((el) => (
                <div
                  className='mobile-search__results__single'
                  onClick={() =>
                    navigate(`/schools/${el.link_id ? el.link_id : el.id}`)
                  }
                >
                  <div className='mobile-search__results__single__logo'>
                    <img src={el?.logo} alt='' />
                  </div>
                  <div className='mobile-search__results__single__details'>
                    <p className='mobile-search__results__single__details__name'>
                      {el?.name}
                    </p>
                    <div className='mobile-search__results__single__details__location'>
                      <Place />
                      <p>{`${el?.state || ''},`} Nigeria</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <p> No data found</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MobilesearchResult;
